import React, { Component } from "react";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Trans, withTranslation } from "react-i18next";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import FormGroup from "@material-ui/core/FormGroup";
import { DatePicker } from "@material-ui/pickers";
import CoreFilter from "./CoreFilter";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Badge } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import { connect } from "react-redux";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Collapse from "@material-ui/core/Collapse";
import Icon from "@mdi/react";
import { mdiFilterVariantRemove, mdiFilterVariant } from "@mdi/js";
import InputLabel from "@material-ui/core/InputLabel";

const styles = (theme) => ({
  container: {},
  paperRoot: {
    display: "flex",
    marginLeft: "auto",
    marginRight: "auto",
  },
  formControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  moreMarginFormControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
  },
  hiddenFormControl: {
    display: "none",
  },
  gridContainer: {
    flexGrow: 1,
  },
  filterWrapper: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
    width: "100%",
  },
  gridItem: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    flexGrow: 1,
    minWidth: theme.spacing(24),
  },
  showClearTitle: {
    visibility: "visible",
  },
  hideClearTitle: {
    visibility: "hidden",
  },
});
const StyledBadge = withStyles((theme) => ({
  anchorOriginTopLeftRectangular: {
    transform: "translate(-150%, 50%)",
  },
  badge: {},
}))(Badge);
export class FilterLists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: (this.props.filter && this.props.filter.title) ? this.props.filter.title : "",
      defaultFilters: [
        "title",
        "createdStart",
        "createdEnd",
        "modifiedStart",
        "modifiedEnd",
      ],
      opened: this.props.isMobile && this.props.menuDialog ? true : false,
      menuCollapseOpened:
        this.props.isMobile && this.props.menuDialog ? false : true,
      titleTimeout: null,
    }
  }
  componentDidUpdate(_prevProps, prevState) {
    if ((!this.props.filter.hasOwnProperty("title") || this.props.filter.title === null) && 
                _prevProps.filter.hasOwnProperty("title") && 
                this.state.title !== ""){
      this.setState({title: ""})
    }
  }
  toggleExpand = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.isMobile && this.props.menuDialog
      ? this.setState((prev) => ({
          menuCollapseOpened: !prev.menuCollapseOpened,
        }))
      : this.setState((prev) => ({ opened: !prev.opened }));
  };
  render() {
    const { classes, t, expanded } = this.props;
    let filterObj = {};
    filterObj.sort = this.props.asPopper === true ? 
        (
          <div className={classes.formControl}>
            <FormControl className={classes.sortBy}>
              <InputLabel htmlFor="sort">
                <Trans i18nKey="global_sort" />
              </InputLabel>
              <Select
                value={this.props.filter.sort}
                onChange={this.props.handleSortChange}
                inputProps={{
                  name: "sort",
                  id: "sort",
                }}
              >
                    <MenuItem value="none">
                      <Trans i18nKey="filter_discussions_sort_none" />
                    </MenuItem>
                    <MenuItem value="title">
                      <Trans i18nKey="global_document_title" />
                    </MenuItem>
                    <MenuItem value="dateCreated">
                      <Trans i18nKey="global_filter_created_date" />
                    </MenuItem>
                    <MenuItem value="dateModified">
                      <Trans i18nKey="global_filter_modified_date" />
                    </MenuItem>
              </Select>
            </FormControl>
            <Button onClick={this.props.toggleSortDirection}>
              {this.props.filter.sortDirection === "ASC" ? (
                <>
                  <ArrowUpwardIcon />
                </>
              ) : (
                <>
                  <ArrowDownwardIcon />
                </>
              )}
            </Button>
          </div>
        ) : ( null)

    filterObj.title = (
      <FormControl className={classes.formControl}>
        {this.props.isFilterSet("title") && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <TextField
          value={this.state.title ? this.state.title : ""}
          InputProps={{
            endAdornment: (
              <IconButton
                size={"small"}
                className={this.state.title !== "" ? classes.showClearTitle : classes.hideClearTitle}
                onClick={() => { this.setState({ title: "" }, () => {this.props.handleTextFieldChangeFromState("title")("")}) }}
              >
                <ClearIcon />
              </IconButton>
            ),
          }}
          onChange={(e) =>
            this.setState(
              { title: e.target.value }
            )
          }
          onKeyUp={(e) => {
              this.state.titleTimeout !== null && clearTimeout(this.state.titleTimeout)
              let timeOut = setTimeout(() => {
                this.props.handleTextFieldChangeFromState("title")(this.state.title)
              },
              350
            )
            this.setState({titleTimeout : timeOut})
          }}
          label={t("filter_searches_search_text")}
          name="title"
        />
      </FormControl>
    );
    filterObj.createdStart = (
      <FormControl className={classes.formControl}>
        <DatePicker
          autoOk
          label={t("filter_documents_created_before")}
          clearable
          disableFuture
          value={
            this.props.filter.createdEnd
              ? moment(this.props.filter.createdEnd)
              : null
          }
          onChange={this.props.handleDateChange("createdEnd")}
        />
      </FormControl>
    );
    filterObj.createdEnd = (
      <FormControl className={classes.formControl}>
        <DatePicker
          autoOk
          label={t("filter_documents_created_after")}
          clearable
          disableFuture
          value={
            this.props.filter.createdStart
              ? moment(this.props.filter.createdStart)
              : null
          }
          onChange={this.props.handleDateChange("createdStart")}
        />
      </FormControl>
    );
    filterObj.modifiedEnd = (
      <FormControl className={classes.formControl}>
        <DatePicker
          autoOk
          label={t("filter_documents_last_modified_before")}
          clearable
          disableFuture
          value={
            this.props.filter.modifiedEnd
              ? moment(this.props.filter.modifiedEnd)
              : null
          }
          onChange={this.props.handleDateChange("modifiedEnd")}
        />
      </FormControl>
    );
    filterObj.modifiedStart = (
      <FormControl className={classes.formControl}>
        <DatePicker
          autoOk
          label={t("filter_documents_last_modified_after")}
          clearable
          disableFuture
          value={
            this.props.filter.modifiedStart
              ? moment(this.props.filter.modifiedStart)
              : null
          }
          onChange={this.props.handleDateChange("modifiedStart")}
        />
      </FormControl>
    );
    let activeFilters = (
      <>
        {!this.state.opened &&
          Object.keys(this.props.filter)
            .filter((filter) => this.props.isFilterSet(filter))
            .map(
              (filter, idx) =>
                filterObj.hasOwnProperty(filter) &&
                this.state.defaultFilters.indexOf(filter) < 0 &&
                filterObj[filter] && (
                  <Grid
                    item
                    xs={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 12 : 6}
                    sm={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 6 : 3}
                    lg={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 4 : 3}
                    classes={{ root: classes.gridItem }}
                  >
                    {filterObj[filter]}
                  </Grid>
                )
            )}
      </>
    );
    let inActiveFilters = (
      <>
        {this.state.opened &&
          Object.keys(filterObj).map(
            (filter, idx) =>
              filterObj.hasOwnProperty(filter) &&
              this.state.defaultFilters.indexOf(filter) < 0 &&
              filterObj[filter] && (
                <Grid
                  item
                  xs={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 12 : 6}
                  sm={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 6 : 3}
                  lg={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 4 : 3}
                  classes={{ root: classes.gridItem }}
                  style={{ maxWidth: this.props.isMobile && "100%" }}
                >
                  {filterObj[filter]}
                </Grid>
              )
          )}
      </>
    );
    let defaultFilters = (
      <>
        <>
          {this.state.defaultFilters.map(
            (filter, idx) =>
              filterObj.hasOwnProperty(filter) &&
              filterObj[filter] && (
                <Grid
                  item
                  xs={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 12 : 6}
                  sm={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 6 : 3}
                  lg={filter === "urgency" || filter === "createdBy" || filter === "categories" ? 4 : 3}
                  classes={{ root: classes.gridItem }}
                  style={{ maxWidth: this.props.isMobile && "100%" }}
                >
                  {filterObj[filter]}
                </Grid>
              )
          )}
        </>
      </>
    );
    return (
      <>
      {this.props.asPopper ? (
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <div className={classes.container}>
            {this.props.showReset && (
              <Button
                className={classes.resetButton}
                onClick={this.props.resetToDefaultFilters}
              >
                <Trans i18nKey="filters_reset_to_default" />
              </Button>
            )}
            <ExpansionPanel
              expanded={expanded === "sort"}
              onChange={this.props.handleExpansionPanelChange("sort")}
            >
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography className={classes.heading}>
                  <Trans i18nKey="global_sort" />
                </Typography>
                <Typography className={classes.secondaryHeading}>
                  <Trans i18nKey="filter_documents_sort_secondary_heading" />
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <div className={classes.sortByContainer}>
                  <Typography className={classes.sortByLabel}>
                    <Trans i18nKey="global_sort" />
                  </Typography>
                  {filterObj.sort}
                  <Button onClick={this.props.toggleSortDirection}>
                    {this.props.filter.sortDirection === "ASC" ? (
                      <>
                        <ArrowUpwardIcon />
                        <Trans i18nKey="global_ascending" />
                      </>
                    ) : (
                      <>
                        <ArrowDownwardIcon />
                        <Trans i18nKey="global_descending" />
                      </>
                    )}
                  </Button>
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
            <ExpansionPanel
              expanded={expanded === "basic"}
              onChange={this.props.handleExpansionPanelChange("basic")}
            >
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography className={classes.heading}>
                  <Trans i18nKey="global_basic" />
                </Typography>
                <Typography className={classes.secondaryHeading}>
                  <Trans i18nKey="filter_searches_basic_secondary_heading" />
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                {filterObj.title}
              </ExpansionPanelDetails>
            </ExpansionPanel>
            <ExpansionPanel
              expanded={expanded === "dates"}
              onChange={this.props.handleExpansionPanelChange("dates")}
            >
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography className={classes.heading}>
                  <Trans i18nKey="global_sort_dates" />
                </Typography>
                <Typography className={classes.secondaryHeading}>
                  <Trans i18nKey="filter_documents_dates_secondary_heading" />
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <div className={classes.datesContainer}>
                  <FormGroup row>
                    {filterObj.createdEnd}
                    {filterObj.createdStart}
                  </FormGroup>
                  <FormGroup row>
                    {filterObj.modifiedEnd}
                    {filterObj.modifiedStart}
                  </FormGroup>
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </div>
        </MuiPickersUtilsProvider>
      ) : (
        <div>
          <ListItem
            button
            onClick={(event) => event && event.stopPropagation()}
            className={classes.listItem}
            style={{
              paddingLeft: this.props.preText ? 0 : 10,
              borderRight: this.props.selected
                ? `2px solid ${this.props.theme.palette.primary.main}`
                : "",
            }}
            ContainerComponent="div"
            disableGutters={true}
            dense={true}
            selected={false}
          >
            {this.props.preText}
            <ListItemText
              primary={
                <>
                  <div className={classes.filterWrapper}>
                    <span>
                      <IconButton
                        onClick={this.props.resetToDefaultFilters}
                        size="large"
                        color={
                          this.props.showReset === true
                            ? "secondary"
                            : "default"
                        }
                        disabled={this.props.showReset === false}
                      >
                        <Icon
                          path={
                            this.props.showReset === true
                              ? mdiFilterVariantRemove
                              : mdiFilterVariant
                          }
                          size={1.5}
                        />
                      </IconButton>
                    </span>
                    <div className={classes.filterWrapper}>
                      <Collapse
                        in={this.state.menuCollapseOpened}
                        timeout="auto"
                        unmountOnExit
                        style={{ width: "100%" }}
                      >
                        <Grid
                          container
                          classes={{ root: classes.gridContainer }}
                          style={{
                            flexDirection: this.props.isMobile && "column",
                          }}
                        >
                          {defaultFilters}
                          {activeFilters}
                          <Collapse
                            in={this.state.opened}
                            timeout="auto"
                            unmountOnExit
                            style={{ width: "100%" }}
                          >
                            <Grid
                              container
                              classes={{ root: classes.gridContainer }}
                              style={{
                                flexDirection:
                                  this.props.isMobile && "column",
                              }}
                            >
                              {inActiveFilters}
                            </Grid>
                          </Collapse>
                        </Grid>
                      </Collapse>
                    </div>
                  </div>
                </>
              }
              secondary={""}
            />
            {!this.props.hideExpand && (
              <IconButton onClick={this.toggleExpand}>
                {this.state.opened ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            )}
          </ListItem>
        </div>
      )
      }
      </>
    )
  }
}
const mapStateToProps = (state) => ({
  documentTypes: state.prefs.documentTypes,
  taxonomyNodeLookup: state.taxonomy.taxonomyNodeLookup,
  currentUser: state.user.currentUser,
  isMobile: state.screen.isMobile,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(CoreFilter(FilterLists))));
